<template>
    <section class="leafly-section bg-gray-100 py-2">
        <div class="container mx-auto  px-4">
            <div class="flex flex-col md:flex-row justify-between items-start mb-6">
                <div class="block">
                    <h2 class="leafly-section-title">You focus on the product, We'll do the Co-Packing.</h2>
                    <p class="leafly-section-second-title">We are your best solution for Custom Packaging</p>
                </div>
                <div class="hidden md:block mt-[-12px] md:mt-0">
                    <nuxt-link :to="'/custom-packaging'" class="inline-flex items-center text-green-600 font-weight-600 hover:text-green-700 mt-4">
                        CUSTOM PACKAGING
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background: new 0 0 200 200; width: 24px; height: 24px" xml:space="preserve">
                            <path fill="currentColor" d="M151.6,51.7l0,98.1c0,0.9-0.7,1.6-1.6,1.6c-0.4,0-0.8-0.2-1.1-0.5L147,149c-0.6-0.6-0.9-1.4-0.9-2.2l0-86.8l-90.5,90.6c-0.6,0.6-1.6,0.6-2.2,0l-2.1-2.1c-0.6-0.6-0.6-1.6,0-2.2l90.6-90.6l-86.8,0c-0.8,0-1.6-0.3-2.2-0.9l-1.9-1.9c-0.6-0.6-0.6-1.6,0-2.2c0.3-0.3,0.7-0.5,1.1-0.5l98.1,0C150.9,50.2,151.6,50.9,151.6,51.7L151.6,51.7z" />
                        </svg>
                    </nuxt-link>
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-[10px]">
                <!-- 服务特点卡片 -->
                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="100">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem]">End-to-End</div>
                    </div>
                    <div class="bg-white py-4 px-3  border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header ">Whole end-to-end solution support</h3>
                        <p class="item-content">Manage your entire packaging order — from concept to delivery, with a team that moves with you.</p>
                    </div>
                </div>

                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="300">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem]">Extensive Options</div>
                    </div>
                    <div class="bg-white py-4 px-3  border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header">Multi-packaging capabilities</h3>
                        <p class="item-content">Choose from a wide range of materials, formats, and finishes to fit your any product.</p>
                    </div>
                </div>

                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="500">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem]">Cost-Effective</div>
                    </div>
                    <div class="bg-white py-4 px-3  border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header">Proactive cost optimization</h3>
                        <p class="item-content">Smart savings, consistent quality — make your packaging always performs.</p>
                    </div>
                </div>

                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="700">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem] ">Expert Design</div>
                    </div>
                    <div class="bg-white py-4 px-3 border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header">Professional design services</h3>
                        <p class="item-content">Enjoy free packaging concepts from our in-house design team, combining function and aesthetics.</p>
                    </div>
                </div>

                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="900">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem]">Quick Samples</div>
                    </div>
                    <div class="bg-white py-4 px-3  border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header">Meticulous proofing</h3>
                        <p class="item-content">Get samples fast to accelerate approvals and production timelines.</p>
                    </div>
                </div>

                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="1100">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem]">Quality Assurance</div>
                    </div>
                    <div class="bg-white py-4 px-3  border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header">Managed manufacturing</h3>
                        <p class="item-content">Our thoroughly managed manufacturing process ensures precise production, consistent quality for all your packaging needs.</p>
                    </div>
                </div>

                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="1300">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem]">On-Time Logistics</div>
                    </div>
                    <div class="bg-white py-4 px-3  border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header">Hassle-free logistics</h3>
                        <p class="item-content">Experience reliable, damage-free delivery with efficient lead times.</p>
                    </div>
                </div>

                <div class="flex flex-col h-full item" data-aos="fade-up" data-aos-delay="1500">
                    <div class="card-header bg-green-600 text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <div class="font-weight-600 text-[1.5rem]">Our Promise</div>
                    </div>
                    <div class="bg-white py-4 px-3  border-gray-300 rounded-b-md flex-grow">
                        <h3 class="item-header">We Promise</h3>
                        <p class="item-content">Support your business with comprehensive packaging solutions designed to help you stay competitive.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped lang="scss">
    .item-header {
        font-size: 1.5rem;
        line-height: 1;
        font-weight: 600;
        padding-bottom: 8px;
    }
    .item-content {
        font-size: 1.15rem;
        font-weight: 400;
        line-height: 1.2;
        color:#777;
    }

    .item {
        &:hover {
            box-shadow: 0 20px 45px rgba(15, 118, 110, 0.28);
        }
    }

    .card-header {
        position: relative;
        overflow: hidden;

        &::before {
            content: "";
            position: absolute;
            top: -20%;
            left: -50%;
            width: 100%;
            height: 160%;
            /* 只保留一条细亮线，去掉大面积光晕 */
            background: linear-gradient(
                120deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 42%,
                rgba(255, 255, 255, 0.95) 50%,
                rgba(255, 255, 255, 0) 58%,
                rgba(255, 255, 255, 0) 100%
            );
            opacity: 0;
            transform: translate3d(-130%, 0, 0) rotate(18deg);
            pointer-events: none;
        }
    }

    .item:hover .card-header::before {
        animation: card-light-move 1.2s ease-out forwards;
    }

    @keyframes card-light-move {
        0% {
            opacity: 0;
            transform: translate3d(-130%, 0, 0) rotate(18deg);
        }
        10% {
            opacity: 1;
        }
        90% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translate3d(150%, 0, 0) rotate(18deg);
        }
    }
   
</style>
